// SessionList.tsx
import React from "react";
import { useAppState } from "../state";

export const SessionList: React.FC = () => {
  const [state, dispatch] = useAppState();
  return (
    <div>
      <ul className="list-none mt-2 text-left">
        {state.sessions.map((session) => (
          <div key={session.id}>
            <li
              className="cursor-pointer text-left  hover:bg-gray-200 p-4 rounded-md flex justify-between items-center"
              onClick={() => {
                dispatch({
                  type: "SELECT_SESSION",
                  payload: { sessionId: session.id },
                });
              }}
            >
              {session.name}
              {state.sessions.length > 1 && (
                <DeleteButton
                  onClick={() => {
                    dispatch({
                      type: "DELETE_SESSION",
                      payload: { sessionId: session.id },
                    });
                  }}
                ></DeleteButton>
              )}
            </li>
          </div>
        ))}
      </ul>
    </div>
  );
};

interface DeleteButtonProps {
  onClick: () => void;
  children?: React.ReactNode;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ onClick }) => {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={onClick}
        className="inline-flex items-center justify-center p-1.5 rounded-full text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
};
